import styles from "./LateJoinSession.module.scss";

import { Trans, useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";

type LateJoinSessionProps = {
  handleJoin: () => void;
  handleReschedule: () => void;
  handleCancel: () => void;
};

export const LateJoinSession = ({
  handleCancel,
  handleJoin,
  handleReschedule,
}: LateJoinSessionProps) => {
  const { t } = useTranslation();

  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>{t("lateJoin.title")}</span>
        <Trans
          i18nKey="lateJoin.description"
          components={{ paragraph: <p className={styles.description} /> }}
        />

        <div className={styles.footer}>
          <AppButton variant="critical" onClick={handleJoin}>
            <span>{t("lateJoin.buttons.join")}</span>
          </AppButton>

          <AppButton variant="outlined" onClick={handleReschedule}>
            <span>{t("lateJoin.buttons.reschedule")}</span>
          </AppButton>

          <AppButton variant="outlined" onClick={handleCancel}>
            <span className={styles.cancelSessionButton}>
              {t("lateJoin.buttons.cancel")}
            </span>
          </AppButton>
        </div>
      </div>
    </PageContainer>
  );
};
